export const routes = [
  {
    path: '/cidade',
    component: () => import(/* webpackChunkName: "city" */ './components/List'),
    name: 'city.list',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id',
    component: () => import(/* webpackChunkName: "city" */ './components/Get'),
    name: 'city.get',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/grupo',
    component: () => import(/* webpackChunkName: "city" */ './components/group/List'),
    name: 'city.group',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/grupo/:grupo',
    component: () => import(/* webpackChunkName: "city" */ './components/group/ListMember'),
    name: 'city.members',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/evidencia/respondida',
    component: () => import(/* webpackChunkName: "city" */ './components/evidence/List'),
    name: 'city.evidence.answered',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/evidencia/evidenciada',
    component: () => import(/* webpackChunkName: "city" */ './components/evidence/List'),
    name: 'city.evidence.evidenced',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/evidencia/aprovada',
    component: () => import(/* webpackChunkName: "city" */ './components/evidence/List'),
    name: 'city.evidence.approved',
    requiresAuth: true
  },
  {
    path: '/cidade/:id/evidencia/rejeitada',
    component: () => import(/* webpackChunkName: "city" */ './components/evidence/List'),
    name: 'city.evidence.rejected',
    requiresAuth: true
  },
  {
    path: '/cidade/:id/termo-referencia',
    component: () => import(/* webpackChunkName: "city" */ '@/modules/reference-term/components/city/List'),
    name: 'city.reference-term',
    requiresAuth: true
  },
  {
    path: '/cidade/:id/resumo-municipio',
    component: () => import(/* webpackChunkName: "city" */ './components/resumoMunicipio/List'),
    name: 'resumoMunicipio.list',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/resumo-municipio/add/:resumoId',
    component: () => import(/* webpackChunkName: "city" */ './components/resumoMunicipio/Edit'),
    name: 'resumoMunicipio.update',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/resumo-municipio/add',
    component: () => import(/* webpackChunkName: "city" */ './components/resumoMunicipio/Edit'),
    name: 'resumoMunicipio.add',
    meta: {
      requiresAuth: true
    }
  },
]
